import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

export interface ConfigPayload {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class PortalConfigService {
  constructor(private apiService: ApiService) {}

  getConfig(tenantId: number): Observable<any> {
    return this.apiService.getAPI(`portal/management/config/${tenantId}`);
  }

  updateConfig(tenantId: number, config: ConfigPayload): Observable<any> {
    // const data = { config: config };
    const data = config['config'];
    return this.apiService.putAPI(`portal/management/config`, tenantId, data);
  }

  initializeConfig(tenantId: number): Observable<any> {
    return this.apiService.postAPI(`portal/management/config/${tenantId}/initialise`, {});
  }
}
